// extracted by mini-css-extract-plugin
module.exports = {"container":"DefaultCell_container__34sOS","zeroContent":"DefaultCell_zeroContent__KlKbT","content":"DefaultCell_content__OGK_1","subContent":"DefaultCell_subContent__eN3Lf"};